<template>
	<div class="course-container" :class="{ frame: $store.getters.isPc }">
		<div class="header">
			<!-- 医科院学习平台 -->
			<header>
				<div class="name"></div>
				<div class="exit link" @click="logout">
					<img src="@/assets/course/close.png" alt="" />
					<span>退出</span>
				</div>
			</header>
			<template v-if="courseList.length">
				<!-- banner -->
				<img src="@/assets/course/banner.jpg" alt="" />
				<!-- 课程标题 -->
				<div class="course-name">已报名课程</div>
			</template>
		</div>
		<template v-if="courseList.length">
			<main>
				<!-- 课程 -->
				<div class="course-item link" v-for="item in courseList" :key="item.id" @click="courseDetail(item)">
					<div><img :src="$store.getters.baseCourseImgUrl + item.index_image" /></div>
					<div class="course-box">
						<div class="course-title">{{ item.name }}</div>
						<p class="course-progress text-ellipsis" v-if="item.chapter">已学至{{ item.chapter }}</p>
						<div class="course-info">
							<div class="course-duration">共{{ item.chaptercoun }}章 {{ item.video_duration }}小时</div>
							<span class="course-progress text-ellipsis" v-if="item.chapter && false">已学至{{ item.chapter }}</span>
						</div>
					</div>
				</div>
			</main>
		</template>
		<template v-else>
			<div class="notopen-box">
				<div class="notopen"></div>
				<div class="text">您没有报名证书，快去报名证书吧！</div>
			</div>
		</template>
	</div>
</template>

<script>
export default {
	data() {
		return {
			courseList: []
		};
	},
	beforeCreate() {
		if (!this.$store.getters.getToken) {
			this.$router.replace('/course/login');
		}
	},
	created() {
		this.getCourseList();
	},
	methods: {
		courseDetail(course) {
			this.$router.push({ path: '/course/detail', query: { id: course.id } });
		},
		// 课程列表
		getCourseList() {
			this.service2('Corder/myCourse').then(res => {
				this.courseList = res.data;
			});
		},
		logout() {
			this.$store.dispatch('logout');
			if (this.$store.getters.isPc) {
				this.$message({
					message: '退出成功',
					type: 'success'
				});
			} else {
				this.$toast('退出成功');
			}
			this.$router.replace({
				path: '/course/login'
			});
		}
	}
};
</script>

<style lang="less" scoped>
.course-container {
	.header {
		position: sticky;
		z-index: 99;
		top: 0;
		left: 0;
		overflow-x: hidden;
		header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			height: 0.8rem;
			padding: 0 0.427rem;
			background-color: #fff;
			.name {
				font-size: 0.73rem;
				font-weight: 400;
				color: #666666;
			}
			.exit {
				display: flex;
				align-items: center;
				font-size: 0.3125rem;
				line-height: 0.3125rem;
				font-weight: 400;
				color: #9e9e9e;
				img {
					margin-right: 0.1rem;
					width: 0.327rem;
					height: 0.327rem;
				}
			}
		}
		img {
			width: 100%;
			// height: 4.25rem;
			vertical-align: middle;
		}
		.course-name {
			width: 100%;
			// height: 1.067rem;
			padding-left: 0.533rem;
			// line-height: 1.067rem;
			font-size: 0.433rem;
			font-weight: 600;
			color: #333333;
			background-color: #fff;
			border-top: 0.233rem solid #ffffff;
		}
	}
	main {
		width: 100%;
		margin-top: -0.233rem;
		box-sizing: border-box;
		padding: 0 0.533rem;
		.course-item {
			display: flex;
			// justify-content: space-between;
			box-sizing: border-box;
			width: 100%;
			padding: 0.533rem 0;
			border-bottom: 1px solid #efefef;
			.course-box {
				display: flex;
				flex-direction: column;
				flex: 1;
				overflow: hidden;
			}
			> div {
				&:nth-child(1) {
					margin-right: 0.32rem;
					img {
						width: 3.653rem;
						height: 2.053rem;
					}
				}
				&:nth-child(2) {
					.course-title {
						font-size: 0.427rem;
						font-weight: 500;
						color: #333333;
						line-height: 0.507rem;
					}
					p {
						width: 5.12rem;
						font-size: 12px;
						color: #666666;
						margin-top: 0.28rem;
					}
					.course-info {
						display: flex;
						justify-content: space-between;
						align-items: center;
						margin-top: 0.28rem;
						width: 100%;
						overflow: hidden;
						.course-duration {
							display: flex;
							align-items: center;
							justify-content: center;
							white-space: nowrap;
							height: 0.507rem;
							padding: 0 0.207rem;
							box-sizing: border-box;
							border-radius: 0.5rem;
							border: 1px solid #c9c9cc;
							font-size: 0.32rem;
							font-weight: 400;
							color: #999999;
							line-height: 0.507rem;
						}
					}
					.course-progress {
						font-size: 0.24rem;
						font-weight: 500;
						color: #017575;
						// padding-left: 10px;
						// box-sizing: border-box;
					}
				}
			}
		}
	}
}
.notopen {
	margin-top: 2.2rem;
	width: 9.6rem;
	height: 4.341rem;
	background: url(~@/assets/notopen.png) center;
	background-size: 9.6rem 4.341rem;
}
.notopen-box {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
.notopen-box .text {
	margin-top: 1.25rem;
	font-size: 0.42rem;
	color: #999;
}
</style>
